/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Okular_PriceInputs */

const en_pc_alt_t_okular_price = /** @type {(inputs: Pc_Alt_T_Okular_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free`)
};

const zh_pc_alt_t_okular_price = /** @type {(inputs: Pc_Alt_T_Okular_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费`)
};

/**
* | output |
* | --- |
* | "Free" |
*
* @param {Pc_Alt_T_Okular_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_okular_price = /** @type {((inputs?: Pc_Alt_T_Okular_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Okular_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_okular_price(inputs)
	return zh_pc_alt_t_okular_price(inputs)
});
export { pc_alt_t_okular_price as "pc.alt.t.okular.price" }